<script setup>
import { computed, ref } from "@vue/reactivity";
import { ApiService } from "@/axios/apiService";
import store from "../../../store";

const apiService = new ApiService();
const emits = defineEmits(["getData"]);
const allCheck = ref(false);

//methods
const checkAll = () => {
  props.rows.forEach((row) => {
    row.check = !allCheck.value;
  });
};

const props = defineProps({
  rows: {
    type: Array,
    required: true,
  },
  allCheck: {
    type: Boolean,
    required: true,
  },
  dataLength: Number,
  pageLength: Number,
  currentPage: Number,
  offset: Number,
  size: Number,
});

const lastIndex = computed(() => {
  if (props.offset + props.size <= props.dataLength) {
    return props.offset + 10;
  } else {
    return props.dataLength;
  }
});

const nol = (x) => {
  const y = x > 9 ? (x > 99 ? x : "" + x) : "0" + x;
  return y;
};

const openConfirm = async (index, station, condition) => {
  let payload = {
    text: `data station ${station} akan di${condition} ?`,
    text1: "",
    funs: "",
  };
  if (condition === "geser") {
    payload.funs = async () => {
      try {
        const data = props.rows[index];

        if (!data.latitude || !data.longitude) {
          store.dispatch("swalError", {
            text: "Latitude/Longitude kosong, data tidak bisa digeser",
          });
          return;
        }

        await apiService.geserkan(data, data.id);
        payload.text1 = "data berhasil digeser";
        emits("getData");
        store.dispatch("swalSuccess", {
          text: payload.text1,
        });
      } catch (error) {
        store.dispatch("swalError", {
          code: error.response.status,
          text: error.response.data.message,
        });
        console.log(error);
      }
    };
  } else if (condition === "replace") {
    payload.funs = async () => {
      try {
        const body = props.rows[index];
        await apiService.replace(body);
        payload.text1 = "berhasil me-replace data";
        store.dispatch("swalSuccess", {
          text: payload.text1,
        });
        emits("getData");
      } catch (error) {
        store.dispatch("swalError", {
          code: error.response.status,
          text: error.response.data.message,
        });
        console.log(error);
      }
    };
  } else if (condition === "gudangkan") {
    payload.funs = async () => {
      try {
        const data = props.rows[index];
        const body = {
          gudangAplikasi: data.appId,
          gudangBatch: data.batch,
          gudangClient: data.pelangganId,
          gudangMts: data.mts,
          gudangStation: data.station,
          duplikatId: data.id,
          perangkatId: "",
        };
        await apiService.gudangkan(body);
        emits("getData");
        payload.text1 = "berhasil menggudangkan data";
        store.dispatch("swalSuccess", {
          text: payload.text1,
        });
      } catch (error) {
        store.dispatch("swalError", {
          code: error.response.status,
          text: error.response.data.message,
        });
        console.log(error);
      }
    };
  }
  store.dispatch("swalConfirm", payload);
};
</script>

<template>
  <div class="table-responsive p-0">
    <table class="table align-items-center mb-0">
      <thead>
        <tr>
          <!-- <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7"></th> -->
          <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">NO</th>
          <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">TGL. UPLOAD</th>
          <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">BATCH</th>
          <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">STATION</th>
          <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">ALASAN</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in props.rows" :key="index">
          <!-- <td class="text-center align-middle"><input type="checkbox" class="checkbox" v-model="row.checked" /></td> -->
          <td class="text-center align-middle">
            <small>{{ props.currentPage > 0 ? index + 1 + props.currentPage * 10 : index + 1 }}</small>
          </td>
          <td class="text-center align-middle">
            <small> {{ `${nol(row.tglUpload[2])} - ${nol(row.tglUpload[1])} - ${nol(row.tglUpload[0])}` }}</small>
          </td>
          <td class="text-center align-middle">
            <small>{{ row.batch }}</small>
          </td>
          <td class="text-center align-middle">
            <small>{{ row.station }}</small>
          </td>
          <td class="text-center align-middle">
            <small>{{ row.alasan }}</small>
          </td>
          <td>
            <div class="justify-content-center mb-2 btn-group float-end" role="group">
              <button v-if="row.alasan === 'Longitude Latitude terdeteksi sama'" type="button" class="btn btn-success btn-sm px-2 py-1" title="geser" @click="openConfirm(index, row.station, 'geser')">
                <i class="fa fa-exchange text-white"></i>
              </button>
              <button v-else @click="openConfirm(index, row.station, 'replace')" type="button" class="btn btn-success btn-sm px-2 py-1" title="replace">
                <i class="fa fa-clone text-white"></i>
              </button>
              <button @click="openConfirm(index, row.station, 'gudangkan')" type="button" class="btn btn-success btn-sm px-2 py-1" title="gudangkan">
                <i class="fa fa-check-circle text-white"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row px-3 mt-2">
      <div class="col-6">
        <h6>
          Showing
          {{ props.offset }}
          to
          {{ lastIndex }}
          from {{ props.dataLength }} entries
        </h6>
      </div>
      <div class="col-6">
        <div class="float-end">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
